import jQuery from 'jquery';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import classNames from 'classnames';

import 'materialize-css/js/forms';
import 'materialize-css/js/dropdown';

let SelectID = 0;

/**
 * Renders a select form element and does the initialization and teardown automatically.
 * It is recommended to use the Option component in combination with this component.
 */
class Select extends Component {

    static propTypes = {
        name: PropTypes.string,
        value: PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.string,
        ]),
        label: PropTypes.string,
        helpText: PropTypes.string,
        multiple: PropTypes.bool,
        children: PropTypes.arrayOf(PropTypes.node),
        onChange: PropTypes.func,
        selectRef: PropTypes.func,
        disabled: PropTypes.bool,
    };

    static defaultProps = {
        name: '',
        label: '',
        helpText: '',
        value: '',
        multiple: null,
        children: null,
        onChange: null,
        selectRef: null,
        disabled: false,
    };

    constructor(props) {
        super(props);

        this.id = SelectID++;
    }

    render() {
        const {value, name, children, label, helpText, multiple, disabled} = this.props;

        return (
            <div className={classNames('input-field', {multiple, empty: value === null})}>
                <select
                    id={`react-select-${this.id}`}
                    value={value}
                    name={name}
                    onChange={this.onChange}
                    ref={this.initSelect}
                    disabled={disabled}>
                    {children}
                </select>
                <label htmlFor={`react-select-${this.id}`}>
                    {helpText ? `${label} (${helpText})` : label}
                </label>
            </div>
        );
    }

    componentDidUpdate() {
        jQuery(this.select).material_select();
    }

    onChange = event => {
        event.preventDefault();
        const {onChange} = this.props;
        return onChange && onChange(event);
    };

    initSelect = node => {
        const {value, selectRef} = this.props;

        if (selectRef) selectRef(node);

        if (node) {
            jQuery(node).on('change', this.onChange);
            jQuery(node).val(value || (node[0] && node[0].value));
            jQuery(node).material_select();
        } else {
            jQuery(this.select).material_select('destroy');
        }

        this.select = node;
    };
}

export default Select;



// WEBPACK FOOTER //
// ./scripts/components/Select.js